module.exports = __webpack_public_path__ + "static/media/lost_neon.36c251bd.wav";